import { appStore } from '@/store';
import { getExperiment } from '@/lib/experiments';
import { features } from '@/lib/features';

export const handleSignupSuppress = (isExistingAccount: boolean): void => {
  const { ui: uiActions, form: formActions } = appStore.getActions();
  const { onboardOption } = appStore.getState().form;

  // Google Pay Later use case does not need to suppress signup
  // as it is always forced signup experience
  // For Google Pay Later we set the existing account message
  // to the right value based on the existing account status
  if (features.isActive('isGooglePayLaterOnly')) {
    uiActions.setShowIsExistingAccountEmailMessage(isExistingAccount);
    return;
  }

  if (getExperiment('suppressSignup')) {
    const canBeToggledOn = features.isActive(
      'shouldDisableOnboardToggleForMembers',
    );

    if (isExistingAccount) {
      formActions.updateOnboardOption('guest');
    } else if (
      // Toggle back on if they are in suppress state
      // and change the email to a none member email
      !isExistingAccount &&
      canBeToggledOn &&
      // Only force toggle back on if user has not manually altered toggle
      !onboardOption.isDirty &&
      // Avoid pointless redux state updates if already signup
      // since this is obj it causes rerenders even if it's the same
      onboardOption.value !== 'signup'
    ) {
      formActions.updateOnboardOption('signup');
    }

    uiActions.setShowIsExistingAccountEmailMessage(isExistingAccount);
  }
};
